import { ChecklistStepConfig } from '../types/checklist';
import { ChecklistStepState } from '../types/checklist-step-state';
import { GrowChecklistStep } from '../types/grow-checklist-steps';

const commonChecklistSteps: ChecklistStepConfig[] = [
  {
    id: GrowChecklistStep.ExpandWithMoreProducts,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_expand_with_more_products_title',
    description: 'txt_growth_checklist_expand_with_more_products_description',
    buttonText: 'txt_find_products_to_sell',
  },
  {
    id: GrowChecklistStep.UpgradeMockups,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_upgrade_mockups_title',
    description: 'txt_growth_checklist_upgrade_mockups_description',
    buttonText: 'txt_try_gelato_plus_for_free',
  },
  {
    id: GrowChecklistStep.RunStoreFromPhone,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_run_store_from_phone_title',
    description: 'txt_growth_checklist_run_store_from_phone_description',
    buttonText: 'txt_download_app',
  },
  {
    id: GrowChecklistStep.SellDesignsOnMoreProductCategories,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_sell_on_more_product_categories_title',
    description: 'txt_growth_checklist_sell_on_more_product_categories_description',
    buttonText: 'txt_read_article',
  },
];

export const starterGrowChecklist: ChecklistStepConfig[] = [
  {
    id: GrowChecklistStep.StoreLink,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_store_link_title',
    description: 'txt_growth_checklist_store_link_description',
    buttonText: 'txt_copy_link',
  },
  ...commonChecklistSteps,
];

export const switcherGrowChecklist: ChecklistStepConfig[] = [
  ...commonChecklistSteps,
  {
    id: GrowChecklistStep.AddSalesChannel,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_add_sales_channel_title',
    description: 'txt_growth_checklist_add_sales_channel_description',
    buttonText: 'txt_create_platform_store',
  },
  {
    id: GrowChecklistStep.TargetCustomersInMoreCountries,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_target_customers_in_more_countries_title',
    description: 'txt_growth_checklist_target_customers_in_more_countries_description',
    buttonText: 'txt_read_article',
  },
  {
    id: GrowChecklistStep.OptimizePricing,
    state: ChecklistStepState.Number,
    label: 'txt_growth_checklist_optimize_pricing_title',
    description: 'txt_growth_checklist_optimize_pricing_description',
    buttonText: 'txt_calculate_your_profits',
  },
];
